import TimeZoneCountryMap from 'data/timezone_country_map.json';

export const guessCountryCode = () => {
  try {
    return (TimeZoneCountryMap as { [timezone: string]: string | undefined })[
      Intl.DateTimeFormat().resolvedOptions().timeZone
    ];
  } catch {
    return undefined;
  }
};
